import { createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'message_threads',
  initialState, reducers
})

export function useMessageThreads(threadIds) {
  return useMonitoredState('message_threads', slice.actions, threadIds)
}

export function useMessageThread(id) {
  const { message_threads, allLoaded: loaded } = useMessageThreads([id])
  return { message_thread: message_threads[0], loaded }
}

export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer